import types from '../../actions.types';

const { PENDING, SUCCESS, FAILED } = types.companies;

const defaultState = {
  pending: false,
  data: {},
  error: null
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case PENDING:
      return Object.assign({}, state, { pending: true });
    case SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        data: action.data.data
      });
    case FAILED:
      return Object.assign({}, state, {
        pending: false,
        data: [],
        error: action.error
      });
    default:
      return state;
  }
}